import { render, staticRenderFns } from "./Side-Buttons.vue?vue&type=template&id=54326b9a&"
import script from "./Side-Buttons.vue?vue&type=script&lang=js&"
export * from "./Side-Buttons.vue?vue&type=script&lang=js&"
import style0 from "./Side-Buttons.vue?vue&type=style&index=0&id=54326b9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports